import API_ENDPOINTS from '../api/endpoints';
import apiClient from '../api/apiClient';

export const createLicense = async (payload) => {
    try {
        const formData = new FormData();
        Object.entries(payload).forEach(([key, value]) => {
            formData.append(key, value);
        });

        const response = await apiClient.post(
            API_ENDPOINTS.EXPERIENCE.LICENSE_CREATE,
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" }
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error creating license:", error);
        throw error;
    }
};

export const createCertificate = async (payload) => {
    try {
        const formData = new FormData();
        Object.entries(payload).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                formData.append(key, value);
            }
        });

        const response = await apiClient.post(
            API_ENDPOINTS.EXPERIENCE.CERTIFICATE_CREATE,
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" }
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error creating certificate:", error);
        throw error;
    }
};

export const fetchLicenses = async (profileId) => {
    try {
        const response = await apiClient.get(`${API_ENDPOINTS.EXPERIENCE.LICENSE_LIST}${profileId}/`);
        return response.data; // returns array of licenses
    } catch (error) {
        console.error("Error fetching licenses:", error);
        throw error;
    }
};

export const fetchCertificates = async (profileId) => {
    try {
        const response = await apiClient.get(`${API_ENDPOINTS.EXPERIENCE.CERTIFICATE_LIST}${profileId}/`);
        return response.data; // returns array of certificates
    } catch (error) {
        console.error("Error fetching certificates:", error);
        throw error;
    }
};

export const updateLicense = async (id, payload) => {
    try {
        const response = await apiClient.patch(API_ENDPOINTS.EXPERIENCE.LICENSE_UPDATE(id), payload);
        return response.data; // returns updated license object
    } catch (error) {
        console.error("Error updating license:", error);
        throw error;
    }
};

export const deleteLicense = async (id) => {
    try {
        const response = await apiClient.delete(API_ENDPOINTS.EXPERIENCE.LICENSE_DELETE(id));
        return response.data; // optional: usually returns empty object
    } catch (error) {
        console.error("Error deleting license:", error);
        throw error;
    }
};

export const updateCertificate = async (id, payload) => {
    try {
        const response = await apiClient.patch(
            API_ENDPOINTS.EXPERIENCE.CERTIFICATE_UPDATE(id),
            payload
        );
        return response.data; // updated certificate object
    } catch (error) {
        console.error("Error updating certificate:", error);
        throw error;
    }
};

export const deleteCertificate = async (id) => {
    try {
        const response = await apiClient.delete(
            API_ENDPOINTS.EXPERIENCE.CERTIFICATE_DELETE(id)
        );
        return response.data; // optional, may be empty {}
    } catch (error) {
        console.error("Error deleting certificate:", error);
        throw error;
    }
};